import { Link } from 'react-router-dom';
import { useScrollAnimation, useStaggerAnimation } from '@/hooks/useScrollAnimation';

const services = [
  {
    title: '아파트 인테리어',
    desc: '평당 최적화된 설계로 넓고 쾌적한 주거 공간을 완성합니다.',
    price: '평당 120만원~',
    img: 'https://public.readdy.ai/ai/img_res/d191dba2490ef2e0e7a59667917437e8.jpg',
    icon: 'ri-building-2-line',
  },
  {
    title: '빌라 인테리어',
    desc: '개성 있는 빌라 공간을 감각적인 디자인으로 변신시킵니다.',
    price: '평당 100만원~',
    img: 'https://readdy.ai/api/search-image?query=stylish%20Korean%20villa%20interior%20design%2C%20cozy%20living%20space%20with%20warm%20wood%20tones%2C%20modern%20kitchen%2C%20tasteful%20decoration%2C%20comfortable%20and%20elegant%20atmosphere&width=600&height=700&seq=svc002&orientation=portrait',
    icon: 'ri-home-4-line',
  },
  {
    title: '오피스텔 인테리어',
    desc: '작은 공간도 효율적으로 활용하는 스마트한 설계를 제공합니다.',
    price: '평당 90만원~',
    img: 'https://readdy.ai/api/search-image?query=compact%20modern%20Korean%20officetel%20interior%20design%2C%20smart%20space%20utilization%2C%20built-in%20furniture%2C%20clean%20minimalist%20style%2C%20functional%20and%20stylish%20small%20apartment&width=600&height=700&seq=svc003&orientation=portrait',
    icon: 'ri-hotel-line',
  },
  {
    title: '상업공간 인테리어',
    desc: '브랜드 아이덴티티를 살린 매력적인 상업 공간을 만들어 드립니다.',
    price: '별도 문의',
    img: 'https://readdy.ai/api/search-image?query=upscale%20Korean%20commercial%20interior%20design%2C%20modern%20cafe%20or%20restaurant%20space%2C%20sophisticated%20brand%20identity%2C%20warm%20lighting%2C%20premium%20materials%2C%20inviting%20atmosphere&width=600&height=700&seq=svc004&orientation=portrait',
    icon: 'ri-store-2-line',
  },
];

export default function ServicesPreview() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, getItemStyle } = useStaggerAnimation(services.length);

  return (
    <section className="bg-[#f7f5f3] py-28 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className="flex flex-col md:flex-row md:items-end justify-between mb-12 md:mb-16 gap-4 md:gap-6 text-center md:text-left"
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? 'translateY(0)' : 'translateY(36px)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
          }}
        >
          <div>
            <span className="text-[#c9a84c] text-xs tracking-[0.3em] uppercase font-medium">Services</span>
            <h2 className="text-3xl md:text-5xl font-light text-[#1a1a1a] mt-3 md:mt-4 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              시공 분야
            </h2>
          </div>
          <Link
            to="/services"
            className="inline-flex items-center justify-center md:justify-start gap-2 text-[#1a1a1a] text-sm font-medium border-b border-[#1a1a1a] pb-1 whitespace-nowrap cursor-pointer hover:text-[#c9a84c] hover:border-[#c9a84c] transition-colors mx-auto md:mx-0"
          >
            전체 서비스 보기
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div
          ref={gridRef as React.RefObject<HTMLDivElement>}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {services.map((svc, i) => (
            <div key={svc.title} className="group cursor-pointer" style={getItemStyle(i)}>
              <div className="relative w-full h-[380px] rounded-2xl overflow-hidden mb-5">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                <div className="absolute bottom-5 left-5 right-5">
                  <span className="inline-block bg-[#c9a84c] text-[#0d0d0d] text-xs font-bold px-3 py-1.5 rounded-full mb-2">
                    {svc.price}
                  </span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#c9a84c]/10 mt-0.5 shrink-0">
                  <i className={`${svc.icon} text-[#c9a84c] text-base`} />
                </div>
                <div>
                  <h3 className="text-[#1a1a1a] font-semibold text-base mb-1">{svc.title}</h3>
                  <p className="text-[#666] text-xs leading-relaxed">{svc.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
